import React from "react";
import { makeStyles } from "@material-ui/core/styles";
// import Home from "./Home";
import Dashboard from "../components/dashboard/Dashboard";
import UserMaster from "./masters/usermaster/UserMaster";
import Cecertificate from "./SerialNumber/Cecertificate";
import ModelMaster from "./ModelMaster/ModelMaster";
import CustomerPage from "./SerialNumber/CustomerPage";

const FormList = ({ name }) => {
  const classes = useStyles();
  switch (name) {
    case "Masters":
      return (
        <div>
          <div className={classes.header}>{"Machine Master Details"}</div>
          <div className={classes.content}>
            <Cecertificate />
          </div>
        </div>
      );
    case "Machine Master Details":
      return (
        <div>
          <div className={classes.header}>{name}</div>
          <div className={classes.content}>
            <Cecertificate />
          </div>
        </div>
      );
    case "Model Master":
      return (
        <div>
          <div className={classes.header}>{name}</div>
          <div className={classes.content}>
            <ModelMaster />
          </div>
        </div>
      );

    case "User Master":
      return (
        <div>
          <div className={classes.header}>{name}</div>
          <div className={classes.content}>
            <UserMaster />
          </div>
        </div>
      );

    case "Customer Page":
      return (
        <div>

          <CustomerPage />

        </div>
      );


  }
};

const useStyles = makeStyles((theme) => ({
  html: {
    height: "100%",
  },
  body: {
    height: "100%",
    display: "flex",
  },
  header: {
    // background: theme.palette.tertiary.gradient,
    color: "black",
    height: "2rem",
    paddingLeft: "1rem",
    fontSize: "1.3rem",
    marginTop: "5rem",
    marginBottom: "0.5rem",
    borderRadius: "0.5rem",
    position: "absolute",
    maxWidth: "95%",
    minWidth: "91%",
    flexGrow: 1,
  },
  content: {
    position: "absolute",
    marginTop: "7.5rem",
    minWidth: "91%",
    maxWidth: "95%",
    minHeight: "93%",
    marginRight: "1.5rem",
    flexGrow: 1,
  },
  contentView: {
    position: "absolute",
    marginTop: "0rem",
    minWidth: "91%",
    maxWidth: "95%",
    minHeight: "93%",
    marginRight: "1.5rem",
    // flexGrow: 1,
  },
  contentViewDash: {
    position: "absolute",
    marginTop: "5rem",
    minWidth: "91%",
    maxWidth: "95%",
    minHeight: "93%",
    marginRight: "1.5rem",
    // flexGrow: 1,
  },
}));

export default FormList;
